import { useTheme } from '@davies-group/white-label-ui/theme';
import React from 'react';
import { Backdrop, Box, CircularProgress, CssBaseline, Fade, Theme, ThemeProvider, Typography } from '@mui/material';

import { useDocumentUpload } from './context/DocumentUploadContext';
import AppContainer from './AppContainer';

export default function AppTheme() {
    const themeData = useTheme();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const { state } = useDocumentUpload();

    React.useEffect(() => {
        const newIsLoaded = themeData.elementStyles !== null && themeData.theme !== null;
        setIsLoaded(newIsLoaded);
    }, [themeData.elementStyles, themeData.theme]);

    return (
        <>
            {themeData.theme && (
                <ThemeProvider theme={themeData.theme}>
                    <CssBaseline />
                    <AppContainer />
                </ThemeProvider>
            )}
            <Fade in={!isLoaded && state.isLoading}>
                <Backdrop
                    sx={{
                        color: '#000',
                        backgroundColor: '#fff',
                        zIndex: (theme: Theme) => theme.zIndex.tooltip + 1,
                    }}
                    open={true}
                >
                    <Box p={2} display="flex" flexGrow={1} justifyContent="center" textAlign="center">
                        <Box my={5}>
                            <Typography variant="h2" gutterBottom>
                                Please wait while we load your data
                            </Typography>
                            <CircularProgress size="5em" thickness={5} style={{ color: '#b3b3b3' }} />
                        </Box>
                    </Box>
                </Backdrop>
            </Fade>
        </>
    );
}
